export const _fr = {
    components: {
        buttons: {
            showButton: "Afficher les filtres",
            hideButton: "Masquer les filtres",
            loadButton: "Afficher les vues enregistrées",
            saveButton: "Sauvegarder la vue à partir des filtres sélectionnés",
            saveButtonOverride: "Ecraser le contenu de la vue avec celui des filtres actuels",
            resetButton: "Réinitialiser les filtres ainsi que le contenu affiché",
            publishButtonOverride: "Publier",
            unpublishButtonOverride: "Dé-publier",
            toggleButton: "Plier / Déplier la barre des filtres"
        },
        selects: {
            divisions: {
                label: "Services",
                placeholder: "Services"
            },
            refResourceCategories: {
                label: "Catégories de ressources",
                placeholder: "Catégories de ressources"
            },
            refResourceTypes: {
                label: "Types de ressources",
                placeholder: "Types de ressources"
            },
            resources: {
                label: "Nom de ressources",
                placeholder: "Ressources"
            },
            refTaskCategories: {
                label: "Catégories d'activités",
                placeholder: "Catégories d'activités"
            },
            refTaskTypes: {
                label: "Types d'activités",
                placeholder: "Types d'activités"
            },
            refGlobalStates: {
                label: "États de planification",
                placeholder: "États de planification"
            },
            refPrefix: {
                label: "Préfixes/Codes de stage",
                placeholder: "Préfixes/Codes de stage"
            },
            trainingCourses: {
                label: "Nom de stages",
                placeholder: "Stages"
            },
            trainingCourseGroups: {
                label: "Groupes",
                placeholder: "Groupes"
            },
            selectValue: {
                label: "Sélectionnez une valeur",
                placeholder: "Sélectionnez une valeur"
            },
            planeType: {
                label: "Types avions",
                placeholder: "Types avions"
            },
            organization: {
                label: "Compagnies",
                placeholder: "Compagnies"
            },
            serviceProvider: {
                label: "Sociétés",
                placeholder: "Sociétés"
            },
            skills: {
                label: "Compétences / Caractéristiques",
                placeholder: "Compétences / Caractéristiques"
            },
            sites: {
                label: "Sites",
                placeholder: "Sites"
            },
            trainee: {
                label: "Stagiaires"
            }
        },
        dateEditor: {
            startEditor: {
                label: "Date de début",
                placeholder: ""
            },
            endEditor: {
                label: "Date de fin",
                placeholder: ""
            }
        },
        filterTemplates: {
            modal: {
                creation: "Ajout d'un filtre prédéfini",
                selection: "Appliquer un filtre prédéfini",
                moreFilterTitle: "Filtres supplémentaires",
                moreFilterButton: "Appliquer"
            },
            editModal: {
                header: "Edition des filtres",
                body: "Vous allez remplacer les filtres enregistrés par ceux sélectionnés actuellement. Souhaitez-vous continuer?",
                confirm: "Continuer",
                cancel: "Annuler"
            },
            publishModal: {
                header: "Modifier la visibilité des filtres",
                body: "Vous allez modifier la visibilité de votre filtre. Souhaitez-vous continuer",
                confirm: "Continuer",
                cancel: "Annuler"
            },
            table: {
                columns: {
                    list: "Liste",
                    apply: "Appliquer",
                    view: {
                        owner: "Créateur",
                        editor: "Dernier modificateur"
                    }
                }

            },
            noFilters: "Aucun filtrage prédéfini n'est disponible.",
            operationCanceled: "Aucun filtre n'a été sélectionné. L'opération a été annulée.",
            moreFiltersTooltip: "Plus de filtres",
            filters: "Filtres"
        }
    }
};

export const _en = {
    components: {
        buttons: {
            showButton: "Show filters",
            hideButton: "Hide filters",
            loadButton: "Show saved views",
            saveButton: "Save the view from the selected filters",
            saveButtonOverride: "Overwrite the view content with that of the current filters",
            resetButton: "Reset the filters and the displayed content",
            publishButtonOverride: "Publish",
            unpublishButtonOverride: "Unpublish",
            toggleButton: "Collapse/Expand the filter bar"
        },
        selects: {
            divisions: {
                label: "Divisions",
                placeholder: "Divisions"
            },
            refResourceCategories: {
                label: "Resources categories",
                placeholder: "Resources categories"
            },
            refResourceTypes: {
                label: "Resource types",
                placeholder: "Resource types"
            },
            resources: {
                label: "Resource name",
                placeholder: "Resource"
            },
            refTaskCategories: {
                label: "Sessions categories",
                placeholder: "Sessions categories"
            },
            refTaskTypes: {
                label: "Sessions types",
                placeholder: "Session types"
            },
            refGlobalStates: {
                label: "Planning states",
                placeholder: "Planning states"
            },
            refPrefix: {
                label: "Training course prefixes/codes",
                placeholder: "Training course prefixes/codes"
            },
            trainingCourses: {
                label: "Training course names",
                placeholder: "Courses"
            },
            trainingCourseGroups: {
                label: "Groups",
                placeholder: "Groups"
            },
            selectValue: {
                label: "Select a value",
                placeholder: "Select a value"
            },
            planeType: {
                label: "Planes types",
                placeholder: "Plane types"
            },
            organization: {
                label: "Airlines",
                placeholder: "Airlines"
            },
            serviceProvider: {
                label: "Companies",
                placeholder: "Companies"
            },
            skills: {
                label: "Skills / Characteristics",
                placeholder: "Skills / Characteristics"
            },
            sites: {
                label: "Sites",
                placeholder: "Sites"
            },
            trainee: {
                label: "Trainees"
            }
        },
        dateEditor: {
            startEditor: {
                label: "Start date",
                placeholder: ""
            },
            endEditor: {
                label: "Finish date",
                placeholder: ""
            }
        },
        filterTemplates: {
            modal: {
                creation: "Adding a predefined filter",
                selection: "Apply a predefined filter",
                moreFilterTitle: "More filters",
                moreFilterButton: "Apply"
            },
            editModal: {
                header: "Edit a predefined filter",
                body: "You are about to replace the predefined filters with the ones currently selected. Do you want to continue?",
                confirm: "Continue",
                cancel: "Cancel"
            },
            publishModal: {
                header: "Change the visibility of the filters",
                body: "You are going to change the visibility of your filter. Do you want to continue?",
                confirm: "Continue",
                cancel: "Cancel"
            },
            table: {
                columns: {
                    list: "List",
                    apply: "Apply",
                    view: {
                        owner: "Creator",
                        editor: "Last editor"
                    }
                }

            },
            noFilters: "No predefined filtering is available.",
            operationCanceled: "No filter was selected. The operation was cancelled.",
            moreFiltersTooltip: "More filters",
            filters: "Filters"
        }
    }
};
